 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import EBOOK_9781955682213TOZERCRISTOHIJOETERNO_INT from '@/components/EBOOK_9781955682213-Tozer-CristoHijoEterno_INT'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/EBOOK_9781955682213-Tozer-CristoHijoEterno_INT",
 			"name" : "EBOOK_9781955682213-Tozer-CristoHijoEterno_INT",
 			"component" : EBOOK_9781955682213TOZERCRISTOHIJOETERNO_INT
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js